module.exports = __webpack_public_path__ + "media/images/ninestars/favicon-74c079e78ea96ce31718585799c9135b.png";